import script from "./CobrancasTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CobrancasTabPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__